import React from 'react';

export default function ShippingPolicyPage() {
  return (
    <div className="cs_shipping_page">
      <div className="container">
        <div className="cs_shipping_container">
          <h1>Shipping Policy</h1>
          <p className="cs_last_updated">Last updated: {new Date().toLocaleDateString()}</p>

          <section>
            <h2>1. Shipping Coverage</h2>
            <p>We currently ship Ayumedix Wellness Capsule within India only. International shipping is not available at this time.</p>
          </section>

          <section>
            <h2>2. Processing Time</h2>
            <ul>
              <li>Orders are processed within 1-2 business days after payment confirmation</li>
              <li>Orders placed on weekends or holidays will be processed on the next business day</li>
              <li>You will receive an order confirmation email with tracking details once shipped</li>
            </ul>
          </section>

          <section>
            <h2>3. Delivery Timeframes</h2>
            <h3>Metro Cities (Mumbai, Delhi, Bangalore, Chennai, Kolkata, Hyderabad)</h3>
            <ul>
              <li>Standard Delivery: 2-4 business days</li>
              <li>Express Delivery: 1-2 business days (additional charges apply)</li>
            </ul>
            
            <h3>Tier 1 Cities</h3>
            <ul>
              <li>Standard Delivery: 3-5 business days</li>
              <li>Express Delivery: 2-3 business days (additional charges apply)</li>
            </ul>
            
            <h3>Tier 2/3 Cities and Rural Areas</h3>
            <ul>
              <li>Standard Delivery: 5-7 business days</li>
              <li>Express delivery may not be available in all locations</li>
            </ul>
          </section>

          <section>
            <h2>4. Shipping Charges</h2>
            <ul>
              <li>Free shipping on orders above ₹999</li>
              <li>Standard shipping: ₹50 for orders below ₹999</li>
              <li>Express shipping: ₹100 additional charges</li>
              <li>Remote area delivery: Additional ₹25 may apply</li>
            </ul>
          </section>

          <section>
            <h2>5. Secure Packaging</h2>
            <p>We ensure that all products are packed securely to prevent damage during transit:</p>
            <ul>
              <li>Plain, unmarked packaging with no product details visible</li>
              <li>Sender name appears as "Ayumedix Healthcare"</li>
              <li>No mention of product name on external packaging</li>
              <li>Secure packaging to prevent damage during transit</li>
            </ul>
          </section>

          <section>
            <h2>6. Address Requirements</h2>
            <ul>
              <li>Complete address with landmark for easy delivery</li>
              <li>Valid mobile number for delivery coordination</li>
              <li>Pincode must be serviceable by our delivery partners</li>
              <li>PO Box addresses are not accepted</li>
            </ul>
          </section>

          <section>
            <h2>7. Delivery Partners</h2>
            <p>We work with trusted logistics partners including:</p>
            <ul>
              <li>Blue Dart</li>
              <li>DTDC</li>
              <li>Delhivery</li>
              <li>India Post (for remote locations)</li>
            </ul>
          </section>

          <section>
            <h2>8. Order Tracking</h2>
            <ul>
              <li>Tracking number provided via SMS and email</li>
              <li>Real-time tracking available on courier partner websites</li>
              <li>Delivery updates sent via SMS</li>
            </ul>
          </section>

          <section>
            <h2>9. Delivery Attempts</h2>
            <ul>
              <li>Up to 3 delivery attempts will be made</li>
              <li>If delivery fails, package will be returned to our warehouse</li>
              <li>Re-shipping charges will apply for failed deliveries due to incorrect address</li>
              <li>Customer must be available to receive the package</li>
            </ul>
          </section>

          <section>
            <h2>10. Damaged or Lost Packages</h2>
            <ul>
              <li>Report damaged packages within 24 hours of delivery</li>
              <li>Replacement will be sent free of charge for damaged items</li>
              <li>Lost packages will be investigated with courier partners</li>
              <li>Refund or replacement provided for confirmed lost packages</li>
            </ul>
          </section>

          <section>
            <h2>11. Undeliverable Packages</h2>
            <p>Packages may be returned if:</p>
            <ul>
              <li>Incorrect or incomplete address provided</li>
              <li>Customer unavailable after multiple delivery attempts</li>
              <li>Refused by customer at delivery</li>
              <li>Pincode not serviceable</li>
            </ul>
          </section>

          <section>
            <h2>12. Contact for Shipping Issues</h2>
            <p>For shipping-related queries, contact us at:</p>
            <p>Email: support@ayumedix.com<br/>
            WhatsApp: <a href="https://wa.me/919313989270" target="_blank" rel="noopener noreferrer">+91 93139 89270</a><br/>
            Support Hours: Mon-Sat, 9 AM - 8 PM IST</p>
          </section>
        </div>
      </div>

      <style jsx>{`
        .cs_shipping_page {
          min-height: 100vh;
          background: #f8f8f8;
          padding: 120px 0 80px;
        }
        .cs_shipping_container {
          max-width: 800px;
          margin: 0 auto;
          background: #ffffff;
          padding: 50px;
          border-radius: 15px;
          box-shadow: 0 8px 25px rgba(18, 18, 18, 0.08);
        }
        .cs_shipping_container h1 {
          color: #121212;
          font-size: 36px;
          font-weight: 700;
          margin-bottom: 10px;
          text-align: center;
        }
        .cs_last_updated {
          text-align: center;
          color: #666;
          margin-bottom: 40px;
          font-style: italic;
        }
        .cs_shipping_container section {
          margin-bottom: 35px;
        }
        .cs_shipping_container h2 {
          color: #121212;
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 15px;
          border-bottom: 2px solid #0b5e4b;
          padding-bottom: 5px;
        }
        .cs_shipping_container h3 {
          color: #121212;
          font-size: 18px;
          font-weight: 600;
          margin: 20px 0 10px;
        }
        .cs_shipping_container p {
          color: #4f4747;
          line-height: 1.6;
          margin-bottom: 15px;
        }
        .cs_shipping_container ul {
          color: #4f4747;
          line-height: 1.6;
          margin-left: 20px;
        }
        .cs_shipping_container li {
          margin-bottom: 8px;
        }
        @media (max-width: 768px) {
          .cs_shipping_page {
            padding: 100px 0 50px;
          }
          .cs_shipping_container {
            margin: 0 20px;
            padding: 30px 25px;
          }
          .cs_shipping_container h1 {
            font-size: 28px;
          }
          .cs_shipping_container h2 {
            font-size: 20px;
          }
        }
      `}</style>
    </div>
  );
}